import { BaseContract } from 'ethers';
import { getProvider } from './getProvider';
export function getContract(chainId, address, abi, signer) {
    signer = signer ?? getProvider(chainId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return new BaseContract(address, abi, signer);
}
